import { POLICY_INFO_PAGE } from './components.constants';
import { SUPPORTED_LOCALES } from './core.constants';

export const APPS_ROUTES = {
  [SUPPORTED_LOCALES.ENGLISH]: {
    LICENSING: '/licensing',
    MAINTENANCE: '/maintenance',
    USERS: '/users',
    RESOURCES: '/resources',
    FORMS: '/forms',
    FAQ: '/faq',
    POLICY: '/',
    NOT_FOUND: '/notfound',
    SERVER_ERROR: '/error',
    FORBIDDEN_ERROR: '/forbidden',
    FORBIDDEN_ERROR_WEBLINK: '/forbidden-weblink',
    EXTERNAL: '/external',
    ADVISOR: '/advisor',
    REPORTS: '/reports',
    AGENCY: '/agency',
    CREATE_AGENCY: '/agency/create',
    ADVISORS: '/advisors',
    RATES: '/rates',
    ALLOCATIONS: '/allocations',
    ADVISOR_REPORTS: '/advisorreports',
    DESTINATION_MULTIPLIERS: '/destination-multipliers'
  },
  [SUPPORTED_LOCALES.FRENCH]: {
    LICENSING: '/licensing',
    MAINTENANCE: '/maintenance',
    USERS: '/users',
    RESOURCES: '/resources',
    FORMS: '/forms',
    FAQ: '/faq',
    POLICY: '/',
    NOT_FOUND: '/notfound',
    SERVER_ERROR: '/error',
    FORBIDDEN_ERROR: '/forbidden',
    FORBIDDEN_ERROR_WEBLINK: '/forbidden-weblink',
    EXTERNAL: '/external',
    ADVISOR: '/advisor',
    REPORTS: '/reports',
    AGENCY: '/agency',
    CREATE_AGENCY: '/agency/create',
    ADVISORS: '/advisors',
    RATES: '/rates',
    ALLOCATIONS: '/allocations',
    ADVISOR_REPORTS: '/advisorreports',
    DESTINATION_MULTIPLIERS: '/destination-multipliers'
  }
};

export const LICENSE_ROUTES = {
  [SUPPORTED_LOCALES.ENGLISH]: {
    LICENSE_ADD: '/licensing/add',
    LICENSE_EDIT: '/licensing/editLicense'
  },
  [SUPPORTED_LOCALES.FRENCH]: {
    LICENSE_ADD: '/licensing/add',
    LICENSE_EDIT: '/licensing/editLicense'
  }
};

export const ADVISOR_ROUTES = {
  [SUPPORTED_LOCALES.ENGLISH]: {
    ADVISOR_ADD: '/advisors/register'
  },
  [SUPPORTED_LOCALES.FRENCH]: {
    ADVISOR_ADD: '/advisors/register'
  }
};

export const LOGIN_ROUTES = {
  CIAM: '/ciam',
  CIAM_LOGIN_ROUTE: '/ciam/handlelogin',
  CIAM_SETUP_ROUTE: '/ciam/setup',
  CIAM_SIGNUP_ROUTE: '/ciam/signup',
  AZURE_WELCOME_PAGE: '/sso',
  AZURE_LOGIN_ROUTE: '/login',
  AUTH_GET_USER: '/user',
  AUTH_SET_USER: '/switch',
  AUTH_SET_CIAM_USER: '/switch-ciam',
  LOGOUT: '/logout',
  AUTH_REFRESH_TOKEN: '/api/auth/refreshToken'
};

export const EMPTY_STRING = '';
export const PORTS = {
  B2B: 3001,
  B2C: 3003,
  COVERME: 3004,
  ADMIN: 4200
};

export enum PROVINCES {
  AB = 'Alberta',
  BC = 'British Columbia',
  MB = 'Manitoba',
  NB = 'New Brunswick',
  NL = 'Newfoundland and Labrador',
  NS = 'Nova Scotia',
  ON = 'Ontario',
  PE = 'Prince Edward Island',
  QC = 'Quebec',
  SK = 'Saskatchewan',
  NT = 'Northwest Territories',
  NU = 'Nunavut',
  YT = 'Yukon'
}
export const PROVINCE_QUEBEC = 'QC';
export const COVERME_ORG = 'CM';
export const MANULIFE_EMPLOYEE_ORG = 'ME';
export const TRANSAT_ORG = 'TC';
export const ORG_CATEGORY_AGENCY = 'AGENCY';
export const ORG_CATEGORY_BROKER = 'BROKERAGE';
export const ORG_CATEGORY_AFFILIATION = 'AFFILIATION';
export const ORG_CATEGORY_SPONSOR = 'SPONSOR';
export const COVERME_REFERENCE_ID = 'CM';

export enum SalesChannelType {
  B2B = 'B2B',
  B2C = 'B2C',
  B2B_API = 'B2B_API',
  B2C_API = 'B2C_API'
}

export enum POLICY_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  REFUNDED = 'REFUNDED',
  QUOTE = 'QUOTE'
}

export enum PLAN_CLASS {
  OCM = 'OCM',
  NAQC = 'NAQC',
  VTC = 'VTC'
}

export const PLAN_PARAMS = {
  COVERAGE_AMOUNT: 'coverageAmount',
  DEDUCTIBLE: 'deductible',
  TRIP_DAYS: 'daysPerTrip',
  SUM_INSURED_AFTER: 'sumInsuredAfter',
  TRIP_COST: 'tripCost'
};

export const LOG_LEVELS = Object.freeze({
  error: 0,
  warn: 1,
  log: 2,
  debug: 3,
  verbose: 4
});

export const QUESTIONNAIRE_ANSWER_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  TOGGLE: 'toggle',
  CHECKBOX: 'checkbox',
  OPTION: 'option'
};

export const TAB_PATH_MAP = {
  [POLICY_INFO_PAGE.ASSOCIATED_POL]: 'policies',
  [POLICY_INFO_PAGE.POL_INFO]: 'edit',
  [POLICY_INFO_PAGE.FINANCIAL_TRANS]: 'financials',
  [POLICY_INFO_PAGE.POL_NOTE]: 'notes',
  [POLICY_INFO_PAGE.POL_DLVR]: 'delivery'
};

export const SUMMARY_VALUE_TYPES = {
  COVERAGE_AMOUNT: 'coverageAmount',
  AMOUNT: 'amount',
  DAYS: 'days'
};

export const CANCEL_LINK = {
  EN: 'https://www.coverme.com/travel-insurance.html?province=ON&agecode=0',
  FR: 'https://www.pourmeproteger.com/assurance-voyage.html?province=ON&agecode=0'
};

export const ALLOWED_TARGET_LINKS = [
  'https://www.manulife.ca/',
  'https://www.manulife.com/',
  'https://www.coverme.com/',
  'https://www.manulife-travel.ca/',
  'https://www.voyagemanuvie.ca/',
  'https://www.manuvie.ca/',
  'https://www.canada.ca/fr/immigration-refugies-citoyennete/services/visiter-canada/super-visa-parents-grands-parents.html',
  'https://www.canada.ca/en/immigration-refugees-citizenship/services/visit-canada/parent-grandparent-super-visa.html'
];

export const MAX_TRIP_COST_OF_ALL_PLANS = 30000;
export const QUOTE_BLANK = 'blankforquote';

/**
 * Enum for feature flag names to ensure consistency and type safety
 */
export enum FEATURE_FLAGS {
  ADVISOR = 'advisor',
  ONE_TO_MANY = 'one_to_many',
  STA_30 = 'sta_30',
  AGENCY_ONBOARDING = 'agency_onboarding',
  DESTINATION_PRICING = 'destination_pricing'
}

export const AdvisorAPRoles = ['ADV', 'MA', 'OFFICE'];
export const APRoles = ['TA', 'ADV', 'MA', 'OFFICE'];

export const ALL_AGENTS_VALUE = 'allForAllAdvisors';
